(() => {
  const SELECTOR = '[data-pianzi-collection-v4]';
  const initialized = new WeakSet();

  function playVisibleMedia(slides, index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-current', i === index);
      slide.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        if (i === index) {
          const promise = video.play();
          promise?.catch?.(() => {});
        } else {
          video.pause();
        }
      });
    });
  }

  function setup(section) {
    if (!section || initialized.has(section)) return;
    const track = section.querySelector('[data-pc4-track]');
    const slides = [...section.querySelectorAll('[data-pc4-slide]')];
    const prev = section.querySelector('[data-pc4-prev]');
    const next = section.querySelector('[data-pc4-next]');
    const dotsHost = section.querySelector('[data-pc4-dots]');
    if (!track || !slides.length) return;
    initialized.add(section);

    let dots = [];
    let frame = 0;
    let dragging = false;
    let suppressClick = false;
    let startX = 0;
    let startScrollLeft = 0;
    const looping = section.dataset.loop === 'true';
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const slidePosition = (slide) => {
      const trackBox = track.getBoundingClientRect();
      const slideBox = slide.getBoundingClientRect();
      return track.scrollLeft + slideBox.left - trackBox.left - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    };
    const nearestIndex = () => {
      let chosen = 0;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const current = Math.abs(slidePosition(slide) - track.scrollLeft);
        if (current < distance) { distance = current; chosen = index; }
      });
      return chosen;
    };
    const scrollToIndex = (requested, smooth = true) => {
      let index = requested;
      if (looping) index = (index + slides.length) % slides.length;
      else index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({
        left: Math.max(0, Math.min(maxScroll(), slidePosition(slides[index]))),
        behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
      });
    };
    const update = () => {
      const index = nearestIndex();
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = !looping && track.scrollLeft <= 2;
      if (next) next.disabled = !looping && track.scrollLeft >= maxScroll() - 2;
      playVisibleMedia(slides, index);
    };

    if (dotsHost) {
      dotsHost.replaceChildren();
      dots = slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pianzi-collection-v4__page-dot';
        dot.setAttribute('aria-label', `Go to collection ${index + 1}`);
        dot.addEventListener('click', () => scrollToIndex(index));
        dotsHost.appendChild(dot);
        return dot;
      });
    }

    prev?.addEventListener('click', () => scrollToIndex(nearestIndex() - 1));
    next?.addEventListener('click', () => scrollToIndex(nearestIndex() + 1));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); scrollToIndex(nearestIndex() - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); scrollToIndex(nearestIndex() + 1); }
    });
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      dragging = true; suppressClick = false; startX = event.clientX; startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging'); track.setPointerCapture?.(event.pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 5) suppressClick = true;
      track.scrollLeft = startScrollLeft - delta;
    });
    const finish = () => {
      if (!dragging) return;
      dragging = false; track.classList.remove('is-dragging'); scrollToIndex(nearestIndex());
    };
    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('lostpointercapture', finish);
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault(); event.stopPropagation(); suppressClick = false;
    }, true);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  }

  function init(scope = document) {
    if (scope.matches?.(SELECTOR)) setup(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(setup);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init(), { once: true }) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
